import { useEffect, useRef } from "react";
import { debug } from "../App";

const useTraceUpdate = (props: any) => {
  const prev = useRef(props);
  useEffect(() => {
    const changedProps = Object.entries(props).reduce((ps, [k, v]) => {
      if (prev.current[k] !== v) {
        // @ts-ignore
        ps[k] = [prev.current[k], v];
      }
      return ps;
    }, {});
    if (Object.keys(changedProps).length > 0) {
      debug("[useTraceUpdate] Changed props:", changedProps);
    }
    prev.current = props;
  });
};

export default useTraceUpdate;
